import React, { useEffect, useMemo, useRef } from 'react';
import { useIntl } from 'umi';
import { Button, Modal } from 'tea-component';
import { omit } from 'lodash-es';
import { useSaveModal } from '../../CreateReport/hooks';
import classNames from 'classnames';
import { UseFormSearch } from '@gp/pages/Pipeline/ProjectDetails/components/GameOverviewEdit/Components/UseFormSearch';
import { useFromConfigMapKey, useUploadingCaptureEffect } from '../SetAsTemplateModal/hooks';
import './index.scss';

const SaveReportModal = (props: any) => {
  const { gameCode, title, dashboardId, tabLayouts, closeModal, isTemplateReport, showContact, tab, tabId } = props;
  const isEdit = !!dashboardId;
  const element = document.querySelector('.dbl-dashboard-body-background');
  const {formatMessage} = useIntl();
  // 上传接口标识,要先拿到图片链接在调取编辑、增加接口等
  const flag = useRef(true);
  // 只编辑，不上传标识
  const controllerRef = useRef();
  const { onDownload, uploading } = useUploadingCaptureEffect({ title , node: element, fileFlag: flag});
  const { onSubmit, modalLoading } = useSaveModal({tabLayouts, gameCode, isEdit, dashboardId, formatMessage, isTemplateReport, tab, tabId, reqCfg: {signal: controllerRef.current?.signal}, showContact });

  const searchFormRef = useRef();
  const { config } = useFromConfigMapKey({
    searchFormRef,
    key: 'setTemplateSaveModal',
    isTemplateReport
  });
  
  useEffect(() => {
    controllerRef.current = new AbortController();
    return ()=>{
      flag.current = false;
      controllerRef.current?.abort();
    };
  }, []);
  
  const handleClickFormSubmit =  (value: any)=>{
    const clearValue = !value?.set_as_template ? ['category', 'template_title'] : [];
    const req :any = omit(value, clearValue);
    if(isTemplateReport){
      req.template_title = req?.dashboard_title;
    }
    // 如果没有设置模板，区分报表与模版
    if(!value?.set_as_template){
    // 如果是模版，需要调接口
      if(isTemplateReport){
      // 先拿到图片链接在执行表单回调
        onDownload().then(({preview_image_url})=>{
          onSubmit({...req, preview_image_url });
        }).catch(() => {
          onSubmit({...req, preview_image_url: '' });
        });
      // 否则正常更新接口
      }else {
        onSubmit({...req });
      }
    // 其他情况，统一处理上传接口
    }else {
    // 先拿到图片链接在执行表单回调
      onDownload().then(({preview_image_url})=>{
        onSubmit({...req, preview_image_url });
      }).catch(() => {
        onSubmit({...req, preview_image_url: '' });
      });
    }
  };

  const SearchComponent = UseFormSearch({
    config,
    getFormValue: handleClickFormSubmit,
    labelSpan: 6,
    isUnpack: false,
    initialValues: {
      dashboard_title: title,
      category: 'game_template',
      template_title: '',
      set_as_template: false
    },
    ref: searchFormRef,
    isShowSearchBtn: false,
    resetCallback: () => {
      flag.current = false;
      closeModal?.();
    },
  });

  const formUserActionsFieldsDisabled = useMemo(()=>{
    if(!searchFormRef?.current?.latestCountRef?.current?.values?.set_as_template){
      return searchFormRef?.current?.latestCountRef?.current?.errors?.dashboard_title;
    }
    return !searchFormRef?.current?.latestCountRef?.current?.valid;
  },[searchFormRef?.current?.latestCountRef?.current]);

  const handleOnclickCancel = ()=>{
    flag.current = false;
    searchFormRef.current?.onclose();
  };

  const handleOnclickSubmit = ()=>{
    flag.current = true;
    searchFormRef.current?.handleSubmit();
  };
  return (
    <Modal
      className={classNames('dbl-report-save-modal',{
        'dbl-report-save-modal-files-hidden': !searchFormRef?.current?.latestCountRef?.current?.values?.set_as_template,
        'dbl-report-save-modal-set-template-hidden': !!isTemplateReport,
      })}
      visible={true}
      destroyOnClose
      size={532}
      caption={formatMessage({id: `dbl_create_dashboard_${isTemplateReport ? 'svae_template' : 'svae_dashboard'}`})}
      onClose={closeModal}
    >
      {SearchComponent}
      <Modal.Footer>
        {/* TODO: 这里接口的loading态以及取消态 */}
        <Button
          loading={modalLoading || uploading}
          type="primary" 
          disabled={formUserActionsFieldsDisabled}
          onClick={handleOnclickSubmit}
        >
          {formatMessage({id: 'dbl_common_save'})}
        </Button>
        <Button type="weak" onClick={handleOnclickCancel}>
          {formatMessage({id: 'dbl_common_cancel'})}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveReportModal;
